/* eslint-disable camelcase */
/**
 * variables to wrap environment configuration values.
 */
var env = process.env.VUE_APP_ENV;
var researcher_api_url = process.env.VUE_APP_API_RESEARCHER;
var api_auth_url = process.env.VUE_APP_API_AUTH;
var app_version = process.env.VUE_APP_VERSION;
var login_url = process.env.VUE_APP_LOGIN_URL;
var demo_url = process.env.VUE_APP_DEMO_URL;
var config_display = process.env.VUE_APP_DISPLAY_LOGIN;
var display_register = process.env.VUE_APP_DISPLAY_REGISTER;
var analysis_api_url = process.env.VUE_APP_API_ANALYSIS;
var ui_respondent_url = process.env.VUE_APP_UI_RESPONDENT;
var display_register = process.env.VUE_APP_DISPLAY_REGISTER;
var register_url = process.env.VUE_APP_REGISTER_URL;
var register_hosting_message = process.env.VUE_APP_REGISTER_HOSTING_MESSAGE;

export const configService = {
	env,
	researcher_api_url,
	api_auth_url,
	app_version,
	login_url,
	demo_url,
	config_display,
	display_register,
	analysis_api_url,
	ui_respondent_url,
	display_register,
	register_url,
	register_hosting_message
}
